module.exports = __webpack_public_path__ + "img/kkb_m290_bc.3374cf47.png";